export enum Stanford2010Version {
    TwoPointOne = 1,
    ThreePointOne = 2,
    FourPointOne = 3
}

export const Stanford2010VersionLabels = {
    [Stanford2010Version.TwoPointOne]: "2.1",
    [Stanford2010Version.ThreePointOne]: "3.1",
    [Stanford2010Version.FourPointOne]: "4.1"
}
